module.exports = __webpack_public_path__ + "img/CS_new_icons_thumbs.bd858563.png";